
<template>
  <article class="cur_con_wrapper">
    <div class="cur_con">
      <header class="header">
        <i class="iconfont">&#xe775;</i>
        <h2>
          {{$t('title.sleep')}}
          <span v-show="showData">({{ startTime }} -- {{ endTime }})</span>
        </h2>
        <div
          class="level"
          v-show="showData"
        >
          <h3>{{$t('title.zhiliang')}}</h3>
          <strong
            :class="sleepColor"
            @click="showDetail(sleepcolor, txt)"
          >{{$t('tag.'+statec)}}</strong>
        </div>
      </header>
      <div v-show="showData">
        <div class="charts">
          <div class="data">
            <keep-alive>
              <div
                class="chart"
                :id="id"
              ></div>
            </keep-alive>
          </div>
          <!--<div class="xA">
            <span>{{startTime}}</span>
            <span>{{endTime}}</span>
          </div>-->
          <ul class="item_list">
            <li>
              <div class="value">
                <strong>{{deps_hour}}</strong>
                <i>{{$t('tag.xiaoshi')}}</i>
                <strong>{{deps_min}}</strong>
                <i>{{$t('tag.fen')}}</i>
              </div>
              <div class="title">
                <i class="dep"></i>
                <span>{{$t('tag.sleep.deepSleep')}}</span>
              </div>
            </li>
            <li>
              <div class="value">
                <strong>{{lghs_hour}}</strong>
                <i>{{$t('tag.xiaoshi')}}</i>
                <strong>{{lghs_min}}</strong>
                <i>{{$t('tag.fen')}}</i>
              </div>
              <div class="title">
                <i class="lghs"></i>
                <span>{{$t('tag.sleep.lightSleep')}}</span>
              </div>
            </li>
          </ul>
          <ul class="item_list">
            <li>
              <div class="value">
                <strong>{{waks_hour}}</strong>
                <i>{{$t('tag.xiaoshi')}}</i>
                <strong>{{waks_min}}</strong>
                <i>{{$t('tag.fen')}}</i>
              </div>
              <div class="title">
                <i class="waks"></i>
                <span>{{$t('tag.sleep.wakeSleep')}}</span>
              </div>
            </li>
            <li>
              <div class="value">
                <strong>{{tots_hour}}</strong>
                <i>{{$t('tag.xiaoshi')}}</i>
                <strong>{{tots_min}}</strong>
                <i>{{$t('tag.fen')}}</i>
              </div>
              <div class="title">
                <span>{{$t('tag.sleep.allTime')}}</span>
              </div>
            </li>
          </ul>
        </div>
        <div class="read">
          <header>
            <i class="iconfont">&#xe61d;</i>
            <h2>{{$t('title.secondaryTitle.canshujiedu')}}</h2>
          </header>
          <div class="content">
            <h3></h3>
            <div
              :class="['article',contentShow ? 'show' : 'hidden']"
              v-html="content"
            ></div>
            <div
              :class="['mask',contentShow ? 'show' : 'hidden']"
              @click="contentToggle"
            >
              <i
                class="iconfont"
                v-show="!contentShow"
              >&#xe632;</i>
              <i
                class="iconfont"
                v-show="contentShow"
              >&#xe633;</i>
            </div>
          </div>
        </div>
      </div>
      <p
        v-show="!showData"
        class="nodata"
      >{{$t('tag.sleep.noday')}}</p>
    </div>
  </article>
</template>
<script>
export default {
  name: "daySleep",
  props: {
    sendTime: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showData: true,
      emit: {},
      id: "daySleep",
      timeData: [],
      lastData: [],
      startTime: "00:00",
      endTime: "00:00",
      lghs_hour: "00",
      lghs_min: "00",
      tots_hour: "00",
      tots_min: "00",
      deps_hour: "00",
      deps_min: "00",
      waks_hour: "00",
      waks_min: "00",
      sleepState: 3,
      sleepLevel: "",
      sleepColor: "",
      contentShow: false,
      content: "",
      statec: "",
      appType: {
        appName: this.$route.params.appName
      },
      txt: ""
    };
  },
  mounted() {
    var echartsDom = document.getElementById(this.id);
    var contentHeight = window.getComputedStyle(echartsDom).height;
    var contentWidth = window.getComputedStyle(echartsDom).width;
    echartsDom.style.height = contentHeight;
    echartsDom.style.width = contentWidth;
  },
  watch: {
    sendTime: function () {
      this.getDayDataInfo();
    }
  },
  computed: {
    options() {
      return {
        grid: {
          containLabel: true,
          top: 10,
          bottom: 10,
          left: -30,
          right: 0
        },
        color: ["#e2e5fd", "#9da8ff", "#5f6fd0"],
        xAxis: {
          type: "category",
          data: this.timeData,
          show: false
        },
        yAxis: {
          show: false
        },
        tooltip: {
          trigger: "axis",
          formatter: function (params) {
            switch (params[0].value) {
              case "2": // 深睡
                return (
                  params[0].axisValue +
                  "<br />" +
                  params[0].seriesName.split(",")[0]
                );
              case "1.5": // 浅睡
                return (
                  params[0].axisValue +
                  "<br />" +
                  params[0].seriesName.split(",")[1]
                );
              case "1": // 清醒
                 return (
                  params[0].axisValue +
                  "<br />" +
                  params[0].seriesName.split(",")[2]
                );
              case "0":
                return (
                  params[0].axisValue 
                  //"<br />" +
                 // params[0].seriesName.split(",")[2]
                );
            }
          },
          axisPointer: {
            animation: true
          }
        },
        series: [
          {
            name: this.$t("components.sleepname"),
            type: "bar",
            barCategoryGap: "-3%",
            data: this.lastData,
            itemStyle: {
              color: function (params) {
                switch (params.data) {
                  case "2":
                    return "#5f6fd0";
                  case "1.5":
                    return "#9da8ff";
                  default:
                    return "#e2e5fd";
                }
              }
            }
          }
        ]
      };
    }
  },
  methods: {
    // getSleepDataStyle (sq) {
    //   let data = null
    //   if (sq === 3) {
    //     data = {
    //       value: 1,
    //       itemStyle: {
    //         normal: {
    //           color: '#e2e5fd'
    //         }
    //       }
    //     }
    //   } else if (sq === 2) {
    //     data = {
    //       value: 2,
    //       itemStyle: {
    //         normal: {
    //           color: '#5f6fd0'
    //         }
    //       }
    //     }
    //   } else if (sq === 1) {
    //     data = {
    //       value: 1.5,
    //       itemStyle: {
    //         normal: {
    //           color: '#9da8ff'
    //         }
    //       }
    //     }
    //   }
    //   return data
    // },
    getDayDataInfo() {
      let postData = {
        date: this.sendTime,
        userid: this.$route.params.userID,
        friendid: this.$route.params.friendID,
        token: this.$route.params.token
      };
      this.$axios
        .getDaysleep(this.appType, postData)
        .then(this.getDayDataInfoSucc);
    },
    getDayDataInfoSucc(res) {
      if (res.code === 0 && res.data) {
        this.showData = true;
        const data = res.data;
        this.timeData = [];
        this.lastData = [];

        for (let item of data.echarts) {
          this.timeData.push(item.time);
          this.lastData.push(item.sq);
        }
        this.lghs_hour = data.outlineData.lghs_hour;
        this.lghs_min = data.outlineData.lghs_min;
        this.tots_hour = data.outlineData.tots_hour;
        this.tots_min = data.outlineData.tots_min;
        this.deps_hour = data.outlineData.deps_hour;
        this.deps_min = data.outlineData.deps_min;
        this.waks_hour = data.outlineData.waks_hour;
        this.waks_min = data.outlineData.waks_min;
        this.sleepState = data.outlineData.sleepState;
        this.sleepLevel = data.outlineData.sleepLevel;
        this.sleepColor = data.outlineData.sleepcolor;
        this.startTime = data.outlineData.startTime;
        this.endTime = data.outlineData.endTime;
        this.statec = data.outlineData.statec;
        this.txt = data.outlineData.txt;
        let p;
        this.content = "";
        for (let item of this.$t("sleep.day." + this.statec)) {
          p = "<p>" + item + "</p>";
          this.content += p;
        }
        this.init();
        this.setOption(this.options);
      } else {
        this.showData = false;
      }
      this.emit.code = res.code;
      // this.emit.time = this.sendTime
      // this.emit.slFlag = this.showData
      this.$emit("daysleepcode", this.emit);
    },
    init() {
      let _this = this;
      this.chart = this.$echarts.init(document.getElementById(this.id));
      window.addEventListener("resize", function () {
        _this.chart = _this.chart.resize();
      });
    },
    setOption(option) {
      if (!this.chart) {
        return;
      }
      this.chart.setOption(option);
    },
    dispose() {
      if (!this.chart) {
        return;
      }
      this.chart.dispose();
      this.chart = null;
    },
    contentToggle() {
      this.contentShow = !this.contentShow;
    },
    showDetail(color, txt) {
      if (color !== "normal") {
        this.$alertPl.show({
          // el: this.$refs.alerts,
          title: this.$t("tag.xiaotieshi.xinlv.title"),
          confirmMsg: this.$t("tag.guanbi"),
          text: txt
        });
      }
    }
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  }
};
</script>
<style lang="stylus" scoped>
@import '~styles/variable.styl';
@import '~styles/CurrentData.styl';

.cur_con_wrapper {
  .cur_con {
    .nodata {
      text-indent: 0.8rem;
      margin-top: 0.3rem;
    }

    .header {
      .level {
        position: absolute;
        top: 0.48rem;
        right: 0.4rem;

        h3 {
          font-size: 0.34rem;
          margin-bottom: 0.1rem;
          font-weight: bold;
          margin-bottom: 0.2rem;
        }

        strong {
          display: flex;
          justify-content: flex-end;
          font-size: 0.34rem;
          font-weight: bold;

          &.normal {
            color: $blueText;
          }

          &.orange {
            color: $orangeText;
          }

          &.red {
            color: $redText;
          }
        }

        span {
          font-size: 0.24rem;
          color: #707070;
        }
      }
    }

    .charts {
      .xA {
        display: flex;
        justify-content: space-between;
        margin-top: -0.5rem;
        margin-bottom: 0.5rem;
        font-size: 0.24rem;

        span {
          display: block;
          color: $greenLink;
        }
      }

      .item_list {
        margin-bottom: 0.4rem;

        li {
          .value {
            color: $greenLink;
          }

          .title {
            justify-content: center;
            font-size: 0.26rem;
            color: #707070;

            i {
              display: inline-block;
              margin-right: 0.1rem;
              width: 0.18rem;
              height: 0.18rem;

              &.dep {
                background-color: #5f6fd0;
              }

              &.lghs {
                background-color: #9da8ff;
              }

              &.waks {
                background-color: #e2e5fd;
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/day-data/components/daySleep.vue